// Port of api/fuel/app/classes/controller/api/monty/groups/delete.php
import DB from 'offline/db'
import Util from 'offline/util'
import Constants from 'offline/constants'
import { currentUser, invalid, persist, recountUserGroups, resolveGroup } from './shared'

export default function(params) {
	var user = currentUser(params)
	var group = resolveGroup(params)
	if (!user || !group) return invalid(Constants.API_ERROR_UNAUTHORISED)
	if (user.get_id() !== group.get_user_id()) return invalid(Constants.API_ERROR_UNAUTHORISED)
	if (group.get_type() !== Constants.GROUP_TYPE_STANDARD) return invalid(Constants.API_ERROR_UNAUTHORISED)

	var memberIds = Util.pluck(DB.query('SELECT user_id FROM link_group_user WHERE group_id = ?', [group.get_id()]), 'user_id')

	DB.run('DELETE FROM link_group_user WHERE group_id = ?', [group.get_id()])
	DB.run('DELETE FROM groups WHERE group_id = ?', [group.get_id()])

	for (var i = 0; i < memberIds.length; i++) {
		recountUserGroups(memberIds[i])
	}

	return persist({
		id: group.get_id(),
		slug: group.get_slug()
	})
}
